/**
 * hash-trigger.js
 * href="#xxx" のリンククリックをトリガーに、特定のUI要素を展開する
 * ※ すでに展開済みの場合は何もしない（閉じることはしない）
 *
 * 使い方: 対応する href をリンクやボタンに設定
 * 例: ナビメニュー / リッチテキスト / schema の Button link
 *
 * 対応トリガー:
 *   - href="#spotlight"    → Spotlight Picks（Special Offers For You）ドロワー
 */

/**
 * #spotlight
 * Spotlight Picks（Special Offers For You）ドロワーを展開する
 * すでに展開済みの場合は何もしない
 */
document.addEventListener('click', function (e) {
  const link = e.target.closest('a[href="#spotlight"], a[href$="#spotlight"]');
  if (!link) return;

  e.preventDefault();

  const spotlight = document.querySelector('spotlight-pick');
  if (!spotlight) return;

  // すでに展開済みなら何もしない
  if (
    spotlight.hasAttribute('open') ||
    spotlight.getAttribute('aria-hidden') === 'false'
  ) {
    return;
  }

  if (typeof spotlight.show === 'function') {
    spotlight.show();
  }
});
